const React         = require('react');
const SharedTooltip = require('../../../shared/components/common/Tooltip.jsx');
const publicUrl = require('../../util/publicUrl');

function Tooltip(props) {
  return (
    <SharedTooltip
      {...props}
      img={publicUrl('/svg/icons/info-dark-grey-icon-spacer-by-cbre.svg')}
    />
  );
}

module.exports = Tooltip;

